import { createFrontendPlugin } from '@backstage/frontend-plugin-api';

export const azurePlugin = createFrontendPlugin({
  pluginId: 'azure',
  title: 'Azure',
  extensions: [],
});
